export const getActiveCooperationPartners = (state) =>
  state.insuranceCompanies.insuranceCompanies.filter((coop) => coop.cooperationLogo).map(({ name, cooperationLogo }) => ({ name, cooperationLogo }));


